import { responsiveGridSizeTimes } from '@townsquare/responsive-grid';

export const OnlyMainColumnMaxWidth = responsiveGridSizeTimes(11);
